module.exports = __webpack_public_path__ + "img/comm_app.15329eca.png";